export const GOOD = { level: 'good', text: null };
/** A worse state shows only once it has lasted this long (a blip does not flash red); a better one shows at once. */
export const WORSEN_AFTER_MS = 2_000;
const RANK = { good: 0, fair: 1, poor: 2 };
export const isWorse = (next, than) => RANK[next] > RANK[than];
/**
 * Green while all is well. In a call LiveKit measures the link: "excellent" is good, "good" is
 * fair (yellow), "poor" and "lost" are poor (red). A call or an app link trying to reconnect is
 * poor too. Outside a call nothing measures the link, so it is only good or, when cut, poor.
 */
export function connectionHealth({ realtime, call, quality }) {
    if (call === 'reconnecting' || realtime !== 'open')
        return { level: 'poor', text: 'Bağlantı koptu, yeniden bağlanılıyor…' };
    if (call === 'connected') {
        if (quality === 'lost')
            return { level: 'poor', text: 'Bağlantı koptu' };
        if (quality === 'poor')
            return { level: 'poor', text: 'Bağlantın çok zayıf' };
        if (quality === 'good')
            return { level: 'fair', text: 'Bağlantın zayıfladı' };
    }
    return GOOD;
}
//# sourceMappingURL=health.js.map